import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row h-100" }
const _hoisted_4 = { class: "col h-100" }
const _hoisted_5 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "checkbox-checked d-flex gap-3 align-items-center" }
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = { class: "form-check" }

import { computed, reactive, watch, onMounted } from 'vue'
import { usePromotionStore } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'promotionBasic',
  setup(__props) {

const promotionStore = usePromotionStore()

const compState = reactive({
    id: '',
    name: '',
    code: '',
    active: false,
    alternateName1: '',
    alternateName2: '',
    taxRate: '',
    member: ''
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.id = tempActivePromotion.value.basic.id
        compState.name = tempActivePromotion.value.basic.name
        compState.code = tempActivePromotion.value.basic.code
        compState.active = tempActivePromotion.value.basic.active
        compState.alternateName1 = tempActivePromotion.value.basic.alternateName1
        compState.alternateName2 = tempActivePromotion.value.basic.alternateName2
        compState.taxRate = tempActivePromotion.value.basic.taxRate
        compState.member = tempActivePromotion.value.basic.member
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.id = promotion.basic.id
        compState.name = promotion.basic.name
        compState.code = promotion.basic.code
        compState.active = promotion.basic.active
        compState.alternateName1 = promotion.basic.alternateName1
        compState.alternateName2 = promotion.basic.alternateName2
        compState.taxRate = promotion.basic.taxRate
        compState.member = promotion.basic.member
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        basic: {
            id: newVal.id,
            name: newVal.name,
            code: newVal.code,
            active: newVal.active,
            alternateName1: newVal.alternateName1,
            alternateName2: newVal.alternateName2,
            taxRate: newVal.taxRate,
            member: newVal.member
        }
    } as Promotion)
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                id: "active-check",
                type: "checkbox",
                value: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.active) = $event))
              }, null, 512), [
                [_vModelCheckbox, compState.active]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "form-check-label",
                for: "active-check"
              }, "Active this rule", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Name")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.name) = $event)),
          class: "form-control",
          type: "text",
          placeholder: "Name",
          maxlength: "32"
        }, null, 512), [
          [_vModelText, compState.name]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Code")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.code) = $event)),
          class: "form-control",
          type: "text",
          placeholder: "Code",
          maxlength: "32"
        }, null, 512), [
          [_vModelText, compState.code]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Alternate Name1")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.alternateName1) = $event)),
          class: "form-control",
          type: "text",
          placeholder: "Code",
          maxlength: "32"
        }, null, 512), [
          [_vModelText, compState.alternateName1]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Alternate Name1")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.alternateName1) = $event)),
          class: "form-control",
          type: "text",
          placeholder: "Code",
          maxlength: "32"
        }, null, 512), [
          [_vModelText, compState.alternateName1]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[15] || (_cache[15] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Rate")
        ], -1)),
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.taxRate) = $event)),
            class: "form-select",
            "aria-label": "Tax Rate"
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("option", { value: "" }, "Tax Rate", -1),
            _createElementVNode("option", { value: "Tax" }, "Tax", -1),
            _createElementVNode("option", { value: "Tax2" }, "Tax2", -1),
            _createElementVNode("option", { value: "Tax3" }, "Tax3", -1)
          ]), 512), [
            [_vModelSelect, compState.taxRate]
          ])
        ])
      ])
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-sm-6" }, null, -1)),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _cache[19] || (_cache[19] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Member")
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "flexRadioDefault1",
              type: "radio",
              name: "flexRadioDefault",
              value: "member",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.member) = $event))
            }, null, 512), [
              [_vModelRadio, compState.member]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              class: "form-check-label",
              for: "flexRadioDefault1"
            }, "Member Only", -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "flexRadioDefault2",
              type: "radio",
              name: "flexRadioDefault",
              value: "nonMember",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.member) = $event))
            }, null, 512), [
              [_vModelRadio, compState.member]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("label", {
              class: "form-check-label",
              for: "flexRadioDefault2"
            }, "Non Member", -1))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "flexRadioDefault3",
              type: "radio",
              name: "flexRadioDefault",
              value: "everyone",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.member) = $event))
            }, null, 512), [
              [_vModelRadio, compState.member]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              class: "form-check-label",
              for: "flexRadioDefault3"
            }, "Everyone", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})